module.exports = __webpack_public_path__ + "gh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gh.svg
// module id = 820
// module chunks = 0